// Supported feature flags

export const BETA_FLAG = "BETA__216615";
export const FeatureFlag = [
  BETA_FLAG,
  "TRAINING_AI__APP__189322",
  "SHAREPOINT_AI__APP__15085",
  "IMAGE_AI__IMAGE_EDIT_MASK__202290",
  "ROLEPLAY_AI_VOICE__207838",
  "REALTIME_CHAT_BETA__205478",
  "SNOW_FLAKE__199912",
  "RESEARCH_AI__APP__205402",
  "MEDDRA_PLUGIN__213657",
  "ISEARCH_AI_COLUMNS__213673",
] as const;
export type FeatureFlagType = (typeof FeatureFlag)[number];

// Map to print feature flags
export const featuresMap: { [key in FeatureFlagType]: string } = {
  BETA__216615: "Beta",
  TRAINING_AI__APP__189322: "Training AI",
  SHAREPOINT_AI__APP__15085: "Sharepoint Plugin",
  IMAGE_AI__IMAGE_EDIT_MASK__202290: "Image AI edit mask UI",
  ROLEPLAY_AI_VOICE__207838: "Roleplay AI Voice",
  REALTIME_CHAT_BETA__205478: "Realtime Chat Beta",
  SNOW_FLAKE__199912: "Snow Flake Plugin",
  RESEARCH_AI__APP__205402: "Research AI App",
  MEDDRA_PLUGIN__213657: "MedDRA Plugin",
  ISEARCH_AI_COLUMNS__213673: "iSearch AI Columns",
};

// Workspace ID Header key
export const WORKSPACE_ID_HEADER = "X-Workspace-Id";

// Durations in miliseconds
export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;
